export default function PerformanceRecords() {
  return <></>;
}
